import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import 'whatwg-fetch';
import { polyfill } from 'es6-promise';
import { isIE } from "../base/common";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import Areas from './Areas';
import Summary from './Summary';
import Question from './Question';

class App extends Component {
    constructor(props) {
        super(props);

        polyfill();

        this.maintainTime = 300000; // 5 minutes - session maintain time
    }

    componentDidMount() {
        this.initSonda();
        this.sessionMaintain();
        this.checkOldBrowsers();
    }

    checkOldBrowsers() {
        if (isIE()) {
            document.querySelector('.page').classList.add('browser-ie');
        }
    }

    initSonda() {
        fetch('/survey-questions')
            .then(response => response.json())
            .then(result => {
                this.props.dispatch({ type: 'INIT_SURVEY', json: result.survey });
                this.props.dispatch({ type: 'INIT_TEST', json: result.survey });
                this.props.dispatch({ type: 'SHOW_SURVEY'});
            });
    }

    sessionMaintain() {
        this.timer = setInterval(() => {
            fetch('/session-up');
        }, this.maintainTime);
    }

    render () {
        if (this.props.showSurvey) {
            return (
                <Router>
                    <Route exact path="/survey" component={Areas} />
                    <Route path="/survey/question" component={Question} />
                    <Route path="/survey/results" component={Summary} />
                </Router>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        selectedArea: state.globals.selectedArea,
        showSurvey: state.globals.showSurvey,
        test: state.test,
    };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./sources/js/components/App.js